import React from 'react';
import { StyleSheet, View, TextInput } from 'react-native';
import PropTypes from 'prop-types';

import AppTheme from '../../AppTheme';

const OTPTextInput = function (props) {
    const {
        containerStyle,
        style,
        LeftComponent,
        RightComponent,
        refCallback,
        ...remainingProps
    } = props;

    return (
        <View style={[containerStyle]}>
            {LeftComponent}
            <TextInput autoFocus={props.index === 0 ? true : undefined}
                {...remainingProps}
                style={[styles.textInputStyle, {borderColor: AppTheme.color.grey.text}]}
                ref={refCallback}
            />
        </View>
    );
};

const styles = StyleSheet.create({

    textInputStyle: {
        padding: 10,
        borderWidth: 1,
        backgroundColor: AppTheme.color.background, height: 40, width: 40,
        borderRadius: 8,
        fontSize: 20,
        textAlign: 'center',
        lineHeight: 24,
        letterSpacing: 0.15,
        fontWeight: 'bold',
    },
});

OTPTextInput.defaultProps = {
    LeftComponent: <></>,
    RightComponent: <></>,
};

OTPTextInput.propTypes = {
    // containerStyle: ViewPropTypes.style,
    // style: ViewPropTypes.style,
    LeftComponent: PropTypes.object,
    RightComponent: PropTypes.object,
    refCallback: PropTypes.func,
};

export default OTPTextInput;